// extracted by mini-css-extract-plugin
export default {"title":"fl83JRnSs7Pi8fxI09Ft","grid":"JZEaiFLRLoriYVMYYfV6","short":"mAxENuLBANZGk2U20lm6","separator":"ZVDluwu7KpCqH3P68q1g","skeleton":"k2DaYgj6tFlCBB6jhrbo"};